module.exports = __webpack_public_path__ + "static/media/cristiane-pacheco.0569244c.png";